module.exports = __webpack_public_path__ + "img/CBEastDeceased52122.878219fd.jpg";